import { render, staticRenderFns } from "./MeasuresListFilters.vue?vue&type=template&id=12a83ef2"
import script from "./MeasuresListFilters.vue?vue&type=script&lang=js"
export * from "./MeasuresListFilters.vue?vue&type=script&lang=js"
import style0 from "./MeasuresListFilters.vue?vue&type=style&index=0&id=12a83ef2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports